import { useEffect, useRef, useState } from 'react';

type IntersectionOptions = {
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
};

type IntersectionEntry = {
  isIntersecting: boolean;
  // Other properties of the IntersectionObserverEntry can be added here
};

type UseIntersectReturnType = [
  React.Dispatch<React.SetStateAction<Element | null>>,
  IntersectionEntry
];

export const useIntersect = ({
  root = null,
  rootMargin,
  threshold = [0],
}: IntersectionOptions): UseIntersectReturnType => {
  const [entry, updateEntry] = useState<IntersectionEntry>({
    isIntersecting: false,
  });
  const [node, setNode] = useState<Element | null>(null);

  const observer = useRef<IntersectionObserver | null>(null);

  const callbackFunction: IntersectionObserverCallback = entries => {
    const [entry] = entries;
    if (entry.isIntersecting) {
      updateEntry(entry);
    }
  };

  useEffect(() => {
    if (observer.current) observer.current.disconnect();

    if ('IntersectionObserver' in window) {
      observer.current = new IntersectionObserver(callbackFunction, {
        root,
        rootMargin,
        threshold,
      });

      if (node) observer.current.observe(node);
    }

    return () => {
      if (observer.current) observer.current.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [node, root, rootMargin, `${threshold}`]);

  return [setNode, entry];
};
